import { useSearchParams } from 'next/navigation';
import { splitAtFirstSpace } from '../utils';

type SearchedValue = { fullTerm: null | string; splitTerm: null | string[] };

const useURLParams = (): {
    searchTopic: SearchedValue;
    searchTerm: SearchedValue;
    params: URLSearchParams;
} => {
    const searchParams = useSearchParams();
    const params = new URLSearchParams(Array.from(searchParams.entries()));
    const searchTermFull = searchParams.get('term');
    const searchTopicFull = searchParams.get('topic');

    const splitTermWithSpace = (fullTerm: string | null) =>
        typeof fullTerm === 'string' ? splitAtFirstSpace(fullTerm.trim()) : null;

    return {
        searchTopic: { fullTerm: searchTopicFull, splitTerm: splitTermWithSpace(searchTopicFull) },
        searchTerm: {
            fullTerm: searchTermFull,
            splitTerm: splitTermWithSpace(searchTermFull)
        },
        params
    };
};

export { useURLParams };
